import { defineComponent as _defineComponent } from 'vue'
import {
  AbVideo,
  AbTitle,
  AbDescription,
  AbSection,
  AbContainer,
  AbLink,
  AbDropdown,
} from '../../../ui';
import { Spacing } from '../../../../helpers/shared-props';
import { CdnImg } from '@webplatform/cdn-image';
import { type TextAlign, type AbVideo as AbVideoType } from '../../../../types';

interface Props {
  id?: string | null;
  title?: string | null;
  description?: string | null;
  textAlign?: TextAlign | null;
  image?: {
    src: string;
    alt: string | null;
  } | null;
  video?: AbVideoType | null;
  links?:
    | {
        text: string;
        src: string;
      }[]
    | null;
  dropdown?: {
    placeholder: string;
    options: {
      value?: any;
      text: string;
      link?: string | null;
    }[];
  } | null;
  spacing?: Spacing | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionSimple',
  props: {
    id: null,
    title: null,
    description: null,
    textAlign: null,
    image: null,
    video: null,
    links: null,
    dropdown: null,
    spacing: null
  },
  setup(__props: any) {

const DEFAULT_TEXT_ALIGN = 'left';



return { __sfc: true,DEFAULT_TEXT_ALIGN, AbVideo, AbTitle, AbDescription, AbSection, AbContainer, AbLink, AbDropdown, CdnImg }
}

})